/**
 * Created by Ning Jiang on 2021-06-03.
 */

import {SymbolStack} from "../../core/reel/stackedsymbol/StackedSymbol";
import {OktoberfestSymbol} from "./OktoberfestSymbol";
import {OktoberfestSymbolState} from "./OktoberfestSymbolConfig";
import {TimelineLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {Oktoberfest} from "../Oktoberfest";
import {Layers, OktoberfestLayers} from "../view/OktoberfestLayers";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class OktoberfestStackedSymbol extends OktoberfestSymbol {
    private _landingAnimation: TimelineSprite;

    constructor(symbolName: string, reelId: number, initState: OktoberfestSymbolState) {
        super(symbolName, reelId, initState);
    }

    private _stack: SymbolStack | null;

    public get stack(): SymbolStack | null {
        return this._stack;
    }

    public set stack(value: SymbolStack | null) {
        if (this._stack || value == null) {
            debugger;
            throw new Error("OktoberfestStackedSymbol.set stack():Cannot change stack!");
        }

        this._stack = value;
        this._stack!.addSymbol(this);
    }

    public onRemove() {
        if (this._stack) {
            this._stack.removeSymbol(this);
            this._stack = null;
        }
        super.onRemove();
    }

    public playLanding(): TimelineLite {
        if (!this._landingAnimation) {
            this._landingAnimation = new TimelineSprite(Oktoberfest.assetLoader.getTextures(this.symbolName.split("*")[0] + "_att"));
            this._landingAnimation.anchor.set(0.5);
            this._landingAnimation.y = this.getCenterPosition().y;
            this._landingAnimation.name = "landing anim";
        }
        const landingTl: TimelineLite = new TimelineLite({paused: false});
        landingTl.add(this._landingAnimation.getAnimationAutoShowHide(true, false));

        const tl: TimelineLite = new TimelineLite();
        tl.add([
            () => this.updateLayers(),
            () => landingTl.play()
        ]);
        tl.to(this, {duration: this._landingAnimation.totalDuration});
        return tl;
    }

    protected createState(state: OktoberfestSymbolState): void {
        super.createState(state);
        if (this._landingAnimation) {
            this._landingAnimation.tint = 0x555555
        }
        if (state === OktoberfestSymbolState.NORMAL) {
            if (this._landingAnimation) {
                this._landingAnimation.tint = 0xFFFFFF
            }
        }
    }

    protected updateLayers() {
        if (this._animation) {
            this.addChild(this._animation);
        }
        if (this._landingAnimation) {
            this.addChild(this._landingAnimation);
        }
    }

    protected getCenterPosition(): PIXI.Point {
        return new PIXI.Point(0,
            ( this.stackedSymbolName.totalNum * this.symbolStep - this.bottomPadding ) * 0.5 - ( this.stackedSymbolName.index * this.symbolStep + this.symbolHeight * 0.5 )
        );
    }

    protected getStateTexture(symName: string, state?: OktoberfestSymbolState): PIXI.Texture[] {
        return super.getStateTexture(this.stackedSymbolName.symName, state);
    }

}